import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";
import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { firebaseConnect } from "react-redux-firebase";
import { Redirect, Route, Switch } from "react-router-dom";
import Header from "./components/header/header.component";
import FaqPage from "./pages/faq/faq.page";
import GemeindePage from "./pages/gemeinde/gemeinde.page";
import HomePage from "./pages/homepage/homepage.page";
import KornspeicherPage from "./pages/kornspeicher/kornspeicher.pages";
import ReportEditPage from "./pages/reports/report-edit.page";
import ReportsPage from "./pages/reports/reports.page";
import ReportPage from "./pages/reports/report.page";
import SignInAndSignUpPage from "./pages/sing-in-and-up/sign-in-and-up.page";
import SpielregelnPage from "./pages/spielregeln/spielregeln.page";
import ImpressumPage from "./pages/impressum/impressum.page";
import DatenschutzerklaerungPage from "./pages/datenschutzerklaerung/datenschutzerklaerung.page";
import RanglistePage from "./pages/rangliste/rangliste.page";
import { setCurrentUser } from "./redux/user/user.actions";
import Datenschutzerklaerung from "./components/datenschutzerklaerung/datenschutzerklaerung.component";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    minHeight: "100vh",
    margin: "0 auto",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    alignItems: "stretch",
    background: "linear-gradient( 90deg, rgb(255,255,255), rgb(236,255,200) );",
  },
  footer: {
    background: "#555",
    padding: theme.spacing(3, 2),
    marginTop: "auto",
  },
  link: {
    margin: 10,
    color: "#fff",
  },
}));
const App = ({ auth, gemeinde, profile, setCurrentUser }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Dialog open={!profile.isEmpty && !profile.einwilligungDatenschutz}>
        <DialogTitle>Datenschutzerklärung</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Wir freuen uns über Ihre Teilnahme am Kreativspiel Ideen säen des
            Dekanats Wetterau-West. Bitte lesen Sie unsere Erklärung zum
            Datenschutz und bestätigen Sie diese durch Betätigen des Buttons am
            Ende der Seite.
          </DialogContentText>
          <Datenschutzerklaerung />
          <DialogContentText>
            <br />
            Ich habe die Datenschutzerklärung zu Ideen säen gelesen und
            akzeptiere diese.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              setCurrentUser({
                ...profile,
                id: auth.uid,
                einwilligungDatenschutz: true,
              });
            }}
          >
            Akzeptieren
          </Button>
        </DialogActions>
      </Dialog>
      <Header />
      <div className={classes.container}>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/berichte" component={ReportsPage} />
            <Route exact path="/kornspeicher" component={KornspeicherPage} />
            {/*
          <Route
            exact
            path="/kornspeicher"
            render={() =>
              gemeinde ? <KornspeicherPage /> : <Redirect to="/" />
            }
          /> */}
            <Route
              exact
              path="/bericht-edit/:berichtId"
              component={ReportEditPage}
            />
            <Route exact path="/bericht/:berichtId" component={ReportPage} />
            <Route path="/faq" component={FaqPage} />
            <Route path="/regeln" component={SpielregelnPage} />

            <Route
              path="/gemeinde"
              render={() => (gemeinde ? <GemeindePage /> : <Redirect to="/" />)}
            />
            <Route
              exact
              path="/signin"
              render={() =>
                auth.uid ? <Redirect to="/" /> : <SignInAndSignUpPage />
              }
            />
            <Route path="/impressum" component={ImpressumPage} />
            <Route
              path="/datenschutzerklaerung"
              component={DatenschutzerklaerungPage}
            />
            <Route path="/rangliste" component={RanglistePage} />
          </Switch>
        </main>

        <footer className={classes.footer}>
          <a
            href="https://bistummainz.de/dekanat/wetterau-west/"
            className={classes.link}
          >
            © 2020 Dekanat Wetterau-West
          </a>
          |
          <a href="/impressum" className={classes.link}>
            Impressum
          </a>
          |
          <a href="/datenschutzerklaerung" className={classes.link}>
            Datenschutzerklärung
          </a>
        </footer>
      </div>
    </div>
  );
};

const mapStateToProps = ({ firebase, gemeinde }) => ({
  auth: firebase.auth,
  profile: firebase.profile,
  gemeinde: gemeinde.gemeinde,
});
const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});
const enhance = compose(
  firebaseConnect((props) => ["gemeinden"]),
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(App);
